import _asyncToGenerator from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import { Model } from '@vuex-orm/core';
import Vue from 'vue';
export default /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        Model.setAxios(Vue.prototype.$axios);
      case 1:
      case "end":
        return _context.stop();
    }
  }, _callee);
})) /* { app, router, Vue ... } */;